query UsersQuery($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    __typename
    id
    accountId
    name
    picture
    ... on AtlassianAccountUser {
      locale
      nickname
      email
    }
    ... on CustomerUser {
      locale
    }
  }
}
